<template>
  <ais-panel class="product-configurator-filter" :class="[filter.visible ? 'visible' : '']">
    <template v-slot:header>
      <header class="product-configurator-filter-header">
        <h3 class="product-configurator-filter-name" @click="toggleVisibility">
          <span
            class="product-configurator-filter-name-text"
            v-html="getTranslatedLabel(filter.label)"
          />
          <span class="product-configurator-filter-values">
            <slo-active-values-count v-if="filter.type === 'checkbox'" :attribute="filter.id" />
            <slo-active-values-toggle v-else-if="filter.type === 'toggle'" :attribute="filter.id" />
            <slo-active-values v-else :attribute="filter.id" :format-value="formatActiveValue" />
          </span>
          <span
            class="expand-collapse-product-configurator-filter"
            :class="{ expanded: filter.visible }"
          >
            <SloIcon name="ChevronDown" />
          </span>
        </h3>
      </header>
    </template>
    <template v-slot:default>
      <div class="product-configurator-filter-body">
        <component :is="filterComponent" :filter="filter" @unit="currentUnit = $event" />
      </div>
    </template>
  </ais-panel>
</template>

<script>
import translations from '../main/translations';
import {isVolume, isFlowRate, isWaterfree} from './filters-config';
import {getLangcode} from '../main/utils';
import components from '../algolia';
import GenericFilter from './filters/GenericFilter.vue';
import IconFilter from './filters/IconFilter.vue';
import FinishFilter from './filters/FinishFilter.vue';
import CheckboxFilter from './filters/CheckboxFilter.vue';
import ToggleFilter from './filters/ToggleFilter.vue';
import SloIcon from '../../lib/components/SloIcon.vue';

const filterComponents = {
  generic: GenericFilter,
  icon: IconFilter,
  finish: FinishFilter,
  checkbox: CheckboxFilter,
  toggle: ToggleFilter
};

export default {
  name: 'ProductConfiguratorFilter',
  components: {
    ...components,
    GenericFilter,
    IconFilter,
    FinishFilter,
    CheckboxFilter,
    ToggleFilter,
    SloIcon
  },
  props: {
    filter: {type: Object, required: true}
  },
  data() {
    return {
      currentUnit: 'gallons'
    };
  },
  computed: {
    langcode() {
      return getLangcode(this.$route.params.langcode);
    },
    filterComponent() {
      return filterComponents[this.filter.type];
    }
  },
  methods: {
    getTranslatedLabel(label) {
      const translation = translations.find(translation => translation.en === label);
      return translation ? translation[this.langcode] : label;
    },
    toggleVisibility() {
      this.$emit('visibility-toggled');
    },
    isVolume(filterId) {
      return isVolume(filterId);
    },
    isFlowRate(filterId) {
      return isFlowRate(filterId);
    },
    convertToLiters(value) {
      let array = value.split('/');
      array = array.map(gallons => {
        let value = (parseFloat(gallons) * 3.78541).toFixed(1);
        if (value === '6.1') return '6.0';
        return value;
      });
      return array.join('/');
    },
    formatValue(value) {
      if (this.isVolume(this.filter.id) && this.currentUnit === 'liters')
        return this.convertToLiters(value);
      if (this.filter.id === 'product_rough_in_dimensions') return `${value}"`;

      return value;
    },
    formatActiveValue(value) {
      if (isWaterfree(value)) return value;
      if (this.isVolume(this.filter.id)) {
        let unit;
        if (this.isFlowRate(this.filter.id)) {
          unit = this.currentUnit === 'gallons' ? 'gpm' : 'Lpm';
        } else {
          unit = this.currentUnit === 'gallons' ? 'gpf' : 'Lpf';
        }
        return `${this.formatValue(value)} ${unit}`;
      }

      return this.formatValue(value);
    }
  }
};
</script>
